<section class="quotation-other-infos">
    <div class="title with-divisor">
        <h2>{{ 'buyer.create-quotation.quotation-other-infos.header.title' | translate }}</h2>
        <p>{{ 'buyer.create-quotation.quotation-other-infos.header.subtitle' | translate }}</p>
    </div>

    <image-picker [imageQuantity]="1" [maxImagesQuantity]="10" [dynamicImages]="true" />

    <form class="observation" [formGroup]="otherInfosFormGroup">
        <p>{{ 'buyer.create-quotation.quotation-other-infos.form.labels.observation' | translate }}</p>
        <textarea name="comment" rows="5" placeholder="{{ 'elemento.generico-input.placeholder-simplified' | translate }}" formControlName="comment" class="form-control comment"></textarea>
    </form>
</section>
